/* eslint-disable @typescript-eslint/no-unused-vars */
import axios, { AxiosRequestConfig, AxiosResponse, Method } from 'axios';

import { FORBIDDEN_ROUTE } from '~/routing/routes';

import { CryptoService } from './CryptoService';
// import querystring from 'querystring';

export const APIService = {
  call(
    method: Method,
    path: string,
    body?: Record<string, any>,
    query?: Record<string, any> | string,
    headers?: Record<string, any>,
    custom: boolean = false,
    responseType?: string,
    shouldEnc?: boolean,
  ): Promise<AxiosResponse> {
    return new Promise((resolve, reject) => {
      const accessToken = localStorage.getItem('accessToken');
      const currentLanguage = localStorage.getItem('i18nextLng');

      let url = '';

      if (custom === false) {
        url = process.env.REACT_APP_API_URL + path;
      } else {
        url = process.env.REACT_APP_RapidAPI_HOST + path;
      }

      if (query) {
        url += query;
        // url += typeof query === 'string' ? query : '?' + querystring.stringify(query);
      }

      const options = {
        responseType,
        method,
        url,
        headers: headers || {},
      } as AxiosRequestConfig;

      // options.headers.common.Origin = 'http://localhost:3000';

      if (accessToken) {
        options.headers.authorization = `Bearer ${accessToken}`;
      }

      if (currentLanguage) {
        options.headers['Accept-Language'] = currentLanguage;
      }

      if (body) {
        if (shouldEnc) {
          const crypto = new CryptoService();
          crypto.setSecretKey(process.env.REACT_APP_APPLI_SECKEY ?? '');
          const encryptData = crypto.encryptData(body);
          options.data = { encData: encryptData };
        } else {
          options.data = body;
        }
      }

      axios(options)
        .then(resolve)
        .catch(e => {
          if (e.response?.status === 401) {
            window.localStorage.removeItem('data');
            window.localStorage.removeItem('transactionDetails');
            window.location.href = FORBIDDEN_ROUTE();
          } else {
            return reject(e);
          }
        });
    });
  },
};
